"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBDocPositive = function SvgBDocPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M108.337 123.777a2.107 2.107 0 01-2.107-2.108V25.386a2.107 2.107 0 014.214 0v96.283a2.107 2.107 0 01-2.107 2.108zM65.116 37.524h-33.19a2.107 2.107 0 010-4.214h33.19a2.107 2.107 0 010 4.214zM88.36 50.793H31.926a2.107 2.107 0 110-4.214H88.36a2.107 2.107 0 110 4.214zM88.36 64.07H31.926a2.107 2.107 0 110-4.215H88.36a2.107 2.107 0 110 4.214zM88.36 77.339H31.926a2.107 2.107 0 110-4.215H88.36a2.107 2.107 0 110 4.215zM88.36 90.615H31.926a2.107 2.107 0 110-4.215H88.36a2.107 2.107 0 110 4.215zM88.36 103.884H31.926a2.107 2.107 0 110-4.215H88.36a2.107 2.107 0 110 4.215z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M98.426 143.69H5.57A5.577 5.577 0 010 138.12V12.125a2.107 2.107 0 01.611-1.49L10.537.626a2.107 2.107 0 013.603 1.482v126.004c0 .745.604 1.349 1.349 1.349h92.848a2.107 2.107 0 010 4.214H15.49a5.57 5.57 0 01-5.564-5.563V7.228l-5.71 5.76v125.133c0 .748.607 1.355 1.355 1.355h92.856a2.107 2.107 0 010 4.215zM108.337 27.493H85.08a2.107 2.107 0 01-2.107-2.107V12.124a2.107 2.107 0 114.215 0V23.28h21.15a2.107 2.107 0 010 4.214z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M101.706 17.561a2.107 2.107 0 01-1.489-.618L87.475 4.215H21.986a2.107 2.107 0 110-4.215h66.36c.558 0 1.094.223 1.489.618l13.346 13.346a2.107 2.107 0 01-1.475 3.597z",
    fill: "#1B7"
  })));
};

var _default = SvgBDocPositive;
exports["default"] = _default;